module.exports = __webpack_public_path__ + "img/p69.296056dc.jpg";